import React from 'react';

import { GeneratedReportsContext } from './GeneratedReportsContext';

export const useGeneratedReportsContext = () => React.useContext(GeneratedReportsContext);
